import { BANNER_TYPE } from '@/utvStore/components/recommend/lp/statics'

const dokomadeBannerHtml = `<span>
  <img src="/static/img/recommend/lp/kurenotori/products/bnr_dokomade_20220726.png">
  <span class="caption">【特別鑑定】人気急上昇の占い師たちが、あなたの恋を徹底鑑定！</span>
  <span class="price">￥888円（税込）→￥0（会員特典）</span>
</span>`

const footBannerList = [
  /*
  <MEMO>
  type: BANNER_TYPE.largeBanner -> バナーが横目一杯に広がるだけ
  extend_body -> imgタグの代わりに登録された文字列がv-htmlで展開される
  outerLink -> trueの場合、target="_blank"で遷移
   */
  {
    type: BANNER_TYPE.largeBanner,
    memo: '知りたい事がサクッとわかる 斗弥占いメニュー一覧',
    img_url: '/static/img/recommend/lp/touwa/products/bnr_touwa_index.png',
    url: '/tag/446'
  },
  {
    type: BANNER_TYPE.banner,
    memo: '法演のMITSURI占い特集',
    img_url: '/static/img/recommend/lp/houen/products/bnr_houen_index.png',
    url: '/products/45'
  },
  {
    type: BANNER_TYPE.banner,
    memo: '暮れの酉占い特集',
    img_url: '/static/img/recommend/lp/kurenotori/products/bnr_kurenotori_menu_list2.png',
    url: '/products/86'
  },
  {
    type: BANNER_TYPE.banner,
    memo: '天宝占術でわかる10年の人生年表',
    img_url: '/static/img/recommend/lp/kanoucoco/products/bnr_kanoucoco_10year_chronology.png',
    url: '/products/87/0001/result'
  }
  /*
  {
    type: BANNER_TYPE.banner,
    memo: '人気急上昇の占い師たち全員で 本格＆豪華占い',
    extend_body: dokomadeBannerHtml,
    url: '/deluxe/lp/1'
  }
   */
]

// 特集ページリンクリスト
const productsIndexLinkList = [
  [
    {
      type: BANNER_TYPE.heading,
      extend_body: 'きょうのあなたへ',
    },
    {
      type: BANNER_TYPE.link,
      memo: 'きょうのあなたへ（一日の運勢）',
      url: '/menu/8371'
    },
    {
      type: BANNER_TYPE.link,
      memo: '＜斗弥タロット＞今、どういう運気の中にある？',
      url: '/menu/8362'
    },
    {
      type: BANNER_TYPE.link,
      memo: 'きょう、何かやる気が起こりません',
      url: '/menu/8269'
    },
    {
      type: BANNER_TYPE.link,
      memo: 'きょう、気になる人を食事に誘ってもいい？',
      url: '/menu/8277'
    },
    {
      type: BANNER_TYPE.link,
      memo: 'きょうの試験、うまくいきそう？',
      url: '/menu/8278'
    },
    {
      type: BANNER_TYPE.link,
      memo: 'きょう仕事の面接。受かるコツを教えて！',
      url: '/menu/8279'
    },
    {
      type: BANNER_TYPE.link,
      memo: 'きょうから10日間の運気予報',
      url: '/menu/8372'
    },
  ],
  [
    {
      type: BANNER_TYPE.heading,
      img_url: '/static/img/recommend/lp/touwa/products/sechead_grp1.png'
    },
    {
      type: BANNER_TYPE.link,
      memo: '【属性開抛】今月の開運術',
      url: '/menu/8226'
    },
    {
      type: BANNER_TYPE.link,
      memo: '【属性開抛】今月の恋愛運',
      url: '/menu/8227'
    },
    {
      type: BANNER_TYPE.link,
      memo: '【属性開抛】今月のお金と仕事',
      url: '/menu/8228'
    },
    {
      type: BANNER_TYPE.link,
      memo: '【属性開抛】自分らしく生きたいと思ったときに',
      url: '/menu/8252'
    },
    {
      type: BANNER_TYPE.link,
      memo: '【属性開抛】お金の不安があるときに',
      url: '/menu/8253'
    },
    {
      type: BANNER_TYPE.link,
      memo: '【属性開抛】解放されるべきエネルギー',
      url: '/menu/8251'
    },
    {
      type: BANNER_TYPE.link,
      memo: '年内に起こる大きな出来事',
      url: '/menu/8267'
    },
    {
      type: BANNER_TYPE.staticImg,
      img_url: '/static/img/recommend/lp/touwa/products/secimg_grp1_a.png'
    },
    {
      type: BANNER_TYPE.link,
      memo: '復縁希望。相手の状況はどうですか？',
      url: '/menu/8249'
    },
    {
      type: BANNER_TYPE.link,
      memo: '今月告白したいと思ってます',
      url: '/menu/8248'
    },
    {
      type: BANNER_TYPE.link,
      memo: '年内なるはやで離婚したい',
      url: '/menu/8268'
    },
    {
      type: BANNER_TYPE.link,
      memo: '今年は起業・転身に適した年ですか？',
      url: '/menu/8324'
    },
    {
      type: BANNER_TYPE.link,
      memo: '今年、転職してお給料を上げたい',
      url: '/menu/8331'
    },
    {
      type: BANNER_TYPE.link,
      memo: '今年引っ越ししたら運気は上がる？',
      url: '/menu/8329'
    },
  ],
  [
    {
      type: BANNER_TYPE.heading,
      img_url: '/static/img/recommend/lp/touwa/products/sechead_grp2.png'
    },
    {
      type: BANNER_TYPE.link,
      memo: '次の恋を占う斗弥タロット',
      url: '/menu/8220'
    },
    {
      type: BANNER_TYPE.link,
      memo: '仕事を占う斗弥タロット',
      url: '/menu/8221'
    },
    {
      type: BANNER_TYPE.link,
      memo: '次に起こる出来事を占う斗弥タロット',
      url: '/menu/8326'
    },
    {
      type: BANNER_TYPE.link,
      memo: '相手の気持ちを知る斗弥タロット',
      url: '/menu/8327'
    },
    {
      type: BANNER_TYPE.link,
      memo: '元恋人は私のことを今どう思ってる？',
      url: '/menu/8328'
    },
    {
      type: BANNER_TYPE.link,
      memo: '不倫中。相手は私との今後をどう考えてる？',
      url: '/menu/8365'
    },
  ],
  [
    {
      type: BANNER_TYPE.heading,
      img_url: '/static/img/recommend/lp/touwa/products/sechead_grp3.png'
    },
    {
      type: BANNER_TYPE.link,
      memo: 'あなたの運命の恋、どんな出会い方をする？',
      url: '/menu/8332'
    },
    {
      type: BANNER_TYPE.link,
      memo: 'あなたの運命の恋、どんな恋になる？',
      url: '/menu/8333'
    },
    {
      type: BANNER_TYPE.link,
      memo: 'あなたの運命の恋、結婚にたどり着くプロセス',
      url: '/menu/8334'
    },
    {
      type: BANNER_TYPE.link,
      memo: 'あなたの運命の恋、運命の恋を確実に手にするために',
      url: '/menu/8335'
    },
  ],
  [
    {
      type: BANNER_TYPE.heading,
      img_url: '/static/img/recommend/lp/touwa/products/sechead_grp4.png'
    },
    {
      type: BANNER_TYPE.link,
      memo: 'あなたは、このために生まれてきた人です',
      url: '/menu/8320'
    },
    {
      type: BANNER_TYPE.link,
      memo: 'あなたの才能が花開くとき',
      url: '/menu/8321'
    },
    {
      type: BANNER_TYPE.link,
      memo: 'あなたに約束された成功の果実',
      url: '/menu/8319'
    },
    {
      type: BANNER_TYPE.link,
      memo: '＜人生のめざめ＞をもたらす出来事',
      url: '/menu/8322'
    },
    {
      type: BANNER_TYPE.link,
      memo: '「生まれてきてよかった」と思える瞬間',
      url: '/menu/8323'
    },
  ],
]


export default {
  footBannerList,
  productsIndexLinkList,
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/recommend/lp/counselor/touwa/info/products.js